@if (data.isMobileAppBanner) {
  <div
    class="flex justify-between items-center p-4 h-28 tablet:h-36 desktop:h-32 rounded-xl desktop:w-full tablet:p-5 desktop:p-6 bg-center bg-cover"
    [style.backgroundImage]="getMobileAppBannerBackground()"
    [attr.aria-labelledby]="'banner-title-' + data.id"
  >
    <div>
      <div
        class="text-white text-mobileH3 tablet:text-tabletH3 font-extrabold text-2xl leading-6 mb-2.5 font-headline desktop:text-desktopH3"
      >
        {{ data.title }}
      </div>
      <div
        class="text-white text-sm tablet:text-base font-semibold leading-5"
        [innerHTML]="data.subTitle"
        [id]="'banner-title-' + data.id"
      ></div>
    </div>
    <div class="flex flex-col gap-3 min-w-[110px]">
      @if (data.appStoreUrl) {
        <a
          [href]="data.appStoreUrl"
          target="_blank"
          aria-label="Download Mobile App on App Store"
          rel="noopener noreferrer"
        >
          <img src="../../../assets/images/app-store-icon.png" alt="" />
        </a>
      }
      @if (data.googlePlayUrl) {
        <a
          [href]="data.googlePlayUrl"
          target="_blank"
          aria-label="Download Mobile App on Google Play"
          rel="noopener noreferrer"
        >
          <img src="../../../../assets/images/google-play-icon.png" alt="" />
        </a>
      }
    </div>
  </div>
}
@if (!data.isMobileAppBanner) {
  <div class="h-24 tablet:h-36 desktop:h-32">
    <a
      [href]="data.url"
      target="_blank"
      class="relative tablet:h-full p-4 rounded-xl flex justify-between items-center mb-3 desktop:w-full desktop:h-full tablet:mb-0 tablet:p-5 desktop:p-6 bg-center bg-cover bg-no-repeat overflow-hidden"
      [style.backgroundImage]="getBannerBackground()"
    >
      <div class="flex z-10">
        @if (data.icon) {
          <img
            class="hidden tablet:block tablet:mr-4"
            [src]="data.icon.url | scCmsImage"
            aria-hidden="true"
            alt=""
          />
        }
        <div>
          <div
            class="text-white text-mobileMd tablet:text-tabletMd font-semibold tablet:font-semibold"
          >
            {{ data.title }}
          </div>
          <p
            [id]="'banner-title-' + data.id"
            class="text-white font-extrabold text-mobileH3 tablet:text-tabletH3 leading-7 font-headline desktop:text-desktopH3"
            [innerHTML]="data.subTitle"
          ></p>
        </div>
      </div>
      @switch (data.linkIcon) {
        @case ('Plus') {
          <div
            class="rounded-full bg-primaryRed h-8 w-8 flex justify-center items-center text-white z-10"
          >
            <sc-svg name="plus" size="w-5 h-5" aria-hidden="true"></sc-svg>
          </div>
        }
        @case ('Pencil') {
          <div
            class="rounded-full bg-white h-8 w-8 flex justify-center items-center text-primaryRed z-10"
          >
            <sc-svg name="pencil" size="w-5 h-5" aria-hidden="true"></sc-svg>
          </div>
        }
        @case ('Arrow') {
          <div
            class="rounded-full bg-primaryRed h-8 w-8 flex justify-center items-center text-white z-10"
          >
            <sc-svg name="arrow-right" size="w-5 h-5" aria-hidden="true"></sc-svg>
          </div>
        }
      }
      @if (data.url === `/${AppRouting.Products}`) {
        <div
          class="absolute top-1/2 right-0 -translate-y-1/2 transform rotate-[-90deg] translate-x-8 desktop:translate-x-6"
        >
          <svg
            width="183"
            height="140"
            viewBox="0 0 30 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.999998 3.30746L1 42.6925C1 43.9669 2.0669 45 3.38298 45L26.617 45C27.9331 45 29 43.9669 29 42.6925L29 7.35404C29 6.73353 28.7419 6.13916 28.284 5.7051L24.0147 1.65851C23.5694 1.23639 22.971 0.999999 22.3478 0.999999L3.38298 1C2.06689 1 0.999998 2.03309 0.999998 3.30746ZM9.20596 42.1338C6.57379 42.1338 4.44 40.0676 4.44 37.5189L4.44 36.4789L9.6 36.4789L9.6 42.1338L9.20596 42.1338ZM10.48 42.1338L14.56 42.1338L14.56 34.1162L12.28 34.1162C11.2859 34.1162 10.48 34.8965 10.48 35.8592L10.48 42.1338ZM15.44 42.1338L19.52 42.1338L19.52 35.8592C19.52 34.8965 18.7141 34.1162 17.72 34.1162L15.44 34.1162L15.44 42.1338ZM20.4 42.1338L20.954 42.1338C23.5862 42.1338 25.72 40.0676 25.72 37.5189L25.72 36.4789L20.4 36.4789L20.4 42.1338ZM25.72 35.6268L25.72 26.6021L20.3855 26.6021C20.2635 27.7402 19.3818 28.6598 18.24 28.8772L18.24 33.3129C19.3948 33.5328 20.2835 34.4708 20.3894 35.6268L25.72 35.6268ZM25.72 25.75L25.72 24.6713C25.72 22.1225 23.5862 20.0563 20.954 20.0563L20.4 20.0563L20.4 25.75L25.72 25.75ZM19.52 20.0563L15.4 20.0563L15.4 28.0739L17.72 28.0739C18.7141 28.0739 19.52 27.2936 19.52 26.331L19.52 20.0563ZM14.52 20.0563L10.48 20.0563L10.48 26.331C10.48 27.2936 11.2859 28.0739 12.28 28.0739L14.52 28.0739L14.52 20.0563ZM9.6 20.0563L9.20596 20.0563C6.57379 20.0563 4.44 22.1225 4.44 24.6713L4.44 25.7113L9.6 25.7113L9.6 20.0563ZM4.44 26.5634L4.44 35.6268L9.6106 35.6268C9.72139 34.418 10.6881 33.4474 11.92 33.2873L11.92 28.9028C10.6881 28.7427 9.72139 27.7722 9.6106 26.5634L4.44 26.5634ZM17.36 33.2641L17.36 28.9261L12.8 28.9261L12.8 33.2641L17.36 33.2641Z"
              fill="none"
              stroke="#262626"
              stroke-width="1"
            />
          </svg>
        </div>
      } @else if (data.url === `/${AppRouting.Products}/${AppRouting.ChangeSubscription}`) {
        <div class="absolute top-1/2 right-0 -translate-y-1/2">
          <svg
            width="90"
            height="96"
            viewBox="0 0 90 96"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity="0.15"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M62.5526 -10.9215C71.7393 -10.4492 80.6676 -7.85476 88.6471 -3.37031V-0.23978L85.7883 0.833518C78.5844 -3.14 70.5527 -5.43987 62.2926 -5.86455C52.3397 -6.37627 42.4372 -4.14573 33.6649 0.583901C24.8925 5.31353 17.587 12.3607 12.5447 20.9571C7.5024 29.5536 4.9169 39.3693 5.07006 49.3343C5.22323 59.2992 8.10918 69.0309 13.4133 77.4683C18.7174 85.9057 26.2361 92.725 35.1496 97.1828C44.0632 101.641 54.0295 103.566 63.962 102.748C72.2051 102.07 80.1624 99.5244 87.2407 95.3314L90.2274 95.9692V99.4454C82.3895 104.173 73.5452 107.041 64.3773 107.795C53.5208 108.688 42.6274 106.584 32.8847 101.712C23.142 96.8392 14.9239 89.3855 9.12636 80.1632C3.32885 70.9409 0.17444 60.304 0.0070288 49.4121C-0.160383 38.5202 2.66563 27.7913 8.17697 18.3952C13.6883 8.99912 21.6734 1.2964 31.2618 -3.8732C40.8502 -9.04279 51.6738 -11.4808 62.5526 -10.9215ZM55.396 48.4215C55.5141 47.7126 55.6618 47.0332 55.839 46.3834H68.5994L70.0172 38.4968H57.8771C58.586 36.2519 59.3836 34.7159 60.2697 33.8889C61.2149 33.0618 62.485 32.6483 64.0801 32.6483C66.0296 32.6483 67.8314 32.796 69.4855 33.0914C71.1987 33.3867 72.4688 33.6526 73.2959 33.8889L76.6632 20.0652C75.4817 19.5926 73.8867 19.1495 71.8781 18.736C69.9286 18.3224 68.0972 18.1157 66.384 18.1157C62.8986 18.1157 59.8266 18.5292 57.1682 19.3563C54.5098 20.1242 52.1763 21.3353 50.1678 22.9894C48.2183 24.6435 46.5346 26.7703 45.1168 29.3696C43.758 31.9098 42.5765 34.9522 41.5722 38.4968H35.3693L33.8629 46.3834H39.7114C39.5932 47.0923 39.4455 47.8308 39.2683 48.5987C39.1501 49.3076 39.032 49.987 38.9138 50.6368H33.0653L31.6475 58.5235H37.9391C37.88 59.2324 37.8505 59.9413 37.8505 60.6502V62.6883C37.8505 65.0513 38.0277 67.2371 38.3822 69.2457C38.7957 71.1952 39.5637 72.8788 40.6861 74.2967C41.8676 75.7145 43.4922 76.8074 45.5599 77.5754C47.6275 78.3434 50.3154 78.7273 53.6237 78.7273C54.687 78.7273 55.8095 78.6683 56.991 78.5501C58.1725 78.432 59.3245 78.2547 60.4469 78.0184C61.5694 77.8412 62.6032 77.6344 63.5484 77.3981C64.4936 77.1618 65.2616 76.9255 65.8524 76.6892L68.5994 62.1566C64.3459 63.3972 59.354 64.0175 53.6237 64.0175C53.6237 63.1314 53.6532 62.2452 53.7123 61.3591C53.7714 60.4139 53.86 59.4687 53.9781 58.5235H66.384L67.8019 50.6368H55.0415C55.1597 49.8689 55.2778 49.1304 55.396 48.4215Z"
              fill="white"
            />
          </svg>
        </div>
      } @else if (data.url === `/${AppRouting.Products}/${AppRouting.TopUp}`) {
        <div class="absolute top-1/2 right-0 -translate-y-1/2">
          <svg
            width="99"
            height="93"
            viewBox="0 0 99 93"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity="0.15"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 9.97508C0 4.74214 4.23164 0.5 9.45164 0.5H109.761C111.613 0.5 113.115 2.00528 113.115 3.86213C113.115 5.71898 111.613 7.22425 109.761 7.22425H9.45164C7.93616 7.22425 6.70761 8.45584 6.70761 9.97508V10.1107L10.9518 14.3654C11.4664 14.8813 12.1644 15.1711 12.8921 15.1711H103.663C108.883 15.1711 113.115 19.4132 113.115 24.6462V83.0249C113.115 88.2579 108.883 92.5 103.663 92.5H81.406C79.5538 92.5 78.0522 90.9947 78.0522 89.1379C78.0522 87.281 79.5538 85.7757 81.406 85.7757H103.663C105.179 85.7757 106.407 84.5442 106.407 83.0249V24.6462C106.407 23.1269 105.179 21.8953 103.663 21.8953H12.8921C10.6133 21.8953 8.41939 21.0704 6.70761 19.5854V83.0249C6.70761 84.5442 7.93616 85.7757 9.45164 85.7757H52.7462C54.2617 85.7757 55.4903 84.5442 55.4903 83.0249V59.0488L50.5444 64.007C49.2346 65.3199 47.1111 65.3199 45.8014 64.007C44.4916 62.694 44.4916 60.5652 45.8014 59.2522L56.4726 48.5545C57.7823 47.2415 59.9058 47.2415 61.2156 48.5545L71.8868 59.2522C73.1965 60.5652 73.1965 62.694 71.8868 64.007C70.577 65.3199 68.4535 65.3199 67.1438 64.007L62.1979 59.0488V83.0249C62.1979 88.2579 57.9662 92.5 52.7462 92.5H9.45164C4.23164 92.5 0 88.2579 0 83.0249V9.97508Z"
              fill="white"
            />
          </svg>
        </div>
      }
    </a>
  </div>
}
